import React, { useCallback } from 'react';
import { NumericTextBoxChangeEvent, NumericTextBoxProps } from '@progress/kendo-react-inputs';
import debounce from 'lodash/debounce';
import { NumericTextBox } from '@components-clean/core/text-box-numeric';

interface NumericSearchBoxProps extends NumericTextBoxProps {
    'data-testid': string;
    debounceTime?: number;
}

const NumericSearchBox = ({
    'data-testid': testId,
    onChange,
    debounceTime,
    value,
    ...props
}: NumericSearchBoxProps) => {
    const debouncedOnChange = useCallback(
        debounce((e: NumericTextBoxChangeEvent) => onChange?.(e), debounceTime),
        [],
    );

    return (
        <NumericTextBox
            {...props}
            data-testid={testId}
            value={value}
            onChange={(event) => {
                // We should possibly look into using min and max values here
                // Instead of just not allowing negative values
                if (event.value == null || !debounceTime) {
                    debouncedOnChange.cancel();
                    onChange?.(event);
                } else {
                    debouncedOnChange(event);
                }
            }}
            className="column-search"
        />
    );
};

export default NumericSearchBox;
